module.exports = __webpack_public_path__ + "img/topback.1a171467.png";